import React, { useEffect } from 'react';
import { ReactComponent as SearchIcon } from '../../../../media/white_search_icon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { State } from '../../../../reducers';
import { actionsGPlistarProductos } from '../../../../actions/action-creators';
import SearchSelect from '../../../../components/Inputs/SearchSelect';
import '../styles/lista-producto.css';

const LIFromFiltrosProducto = () => {
    const formProductos = useSelector((state: State) => state.gestionProducto.listarProductos.formBuscar);
    const arrayProductos = useSelector((state: State) => state.gestionProducto.listarProductos.arrayProductos);
    const { unidadesMedida } = useSelector((state: State) => state.catalogos);
    const dispatch = useDispatch();
    const acciones = bindActionCreators(actionsGPlistarProductos, dispatch);

    useEffect(() => {
        if (!formProductos.codigoProducto && !formProductos.descripcion && !formProductos.tipoItem && !formProductos.unidadMedida && arrayProductos.length > 0) {
            acciones.gp_lp_BuscarProducto(true);
        }
    }, [formProductos, arrayProductos, acciones]);

    const buscar = (e: React.FormEvent) => {
        e.preventDefault();
        acciones.gp_lp_BuscarProducto();
    };

    const handleTipoItemChange = (selected: any) => {
    const value = selected ? selected.value : '';
    acciones.gp_lp_FormBuscarHandleChange({
        target: { name: 'tipoItem', value: value.toString() }
    } as unknown as React.ChangeEvent<HTMLInputElement>);
};


const handleUnidadMedidaChange = (selected: any) => {
    const fakeEvent = {
        target: {
            name: 'unidadMedida',
            value: selected ? selected.value : ''
        }
    } as unknown as React.ChangeEvent<HTMLInputElement>;
    acciones.gp_lp_FormBuscarHandleChange(fakeEvent);
};


    const tipoItemOptions = [
        { value: '0', label: 'Servicio' },
        { value: '1', label: 'Producto' }
    ];
    const limpiarFiltros = () => {
    acciones.gp_lp_FormBuscarHandleChange({
        target: { name: 'codigoProducto', value: '' }
    } as unknown as React.ChangeEvent<HTMLInputElement>);
    acciones.gp_lp_FormBuscarHandleChange({
        target: { name: 'descripcion', value: '' }
    } as unknown as React.ChangeEvent<HTMLInputElement>);
    acciones.gp_lp_FormBuscarHandleChange({
        target: { name: 'tipoItem', value: '' }
    } as unknown as React.ChangeEvent<HTMLInputElement>);
    acciones.gp_lp_FormBuscarHandleChange({
        target: { name: 'unidadMedida', value: '' }
    } as unknown as React.ChangeEvent<HTMLInputElement>);
    acciones.gp_lp_BuscarProducto(); // vuelve a cargar todos los productos
};
    return (
        <form className="listar-producto-form-filter-wrapper" onSubmit={buscar}>

            <div className='listar-producto-form-filter'>
                {/* Filtro por Código de Producto */}
                <div className='filter-field'>
                    <label htmlFor='codigoProducto' className='field-label m'>
                        Cód. Prod. (de tu inventario)
                    </label>
                    <input
                        autoComplete='off'
                        type='text'
                        className='m text-field normal w-input'
                        maxLength={100}
                        name='codigoProducto'
                        placeholder='Código de producto'
                        onChange={acciones.gp_lp_FormBuscarHandleChange}
                        value={formProductos.codigoProducto}
                    />
                </div>

                {/* Filtro por Descripción del producto */}
                <div className='filter-field'>
                    <label htmlFor='descripcion' className='field-label m'>
                        Descripción del producto
                    </label>
                    <input
                        autoComplete='off'
                        type='text'
                        className='m text-field normal w-input'
                        maxLength={255}
                        name='descripcion'
                        placeholder='Descripción'
                        onChange={acciones.gp_lp_FormBuscarHandleChange}
                        value={formProductos.descripcion}
                    />
                </div>

                {/* Filtro por Servicio o producto */}
                <div className='filter-field tipo-producto'>
                    <label htmlFor='tipoItem' className='field-label m'>
                        Servicio o producto
                    </label>
                    <div style={{ width: '220px' }}>
                        <SearchSelect
                            data={tipoItemOptions}
                            keyNameText='label'
                            keyNameValue='value'
                            placeholder='Selecciona...'
                            value={formProductos.tipoItem}
                            onChange={handleTipoItemChange}
                            name='tipoItem'
                            disabled={false}
                        />
                    </div>
                </div>
                {/* Filtro por Unidad de medida */}
                <div className='filter-field'>
                    <label htmlFor='unidadMedida' className='field-label m'>
                        Unidad de medida
                    </label>
                    <div style={{ width: '220px' }}>
                    <SearchSelect
                        data={unidadesMedida}
                        keyNameText='valor'
                        keyNameValue='codigo'
                        placeholder='Selecciona unidad'
                        value={formProductos.unidadMedida}
                        onChange={handleUnidadMedidaChange}
                        name='unidadMedida'
                        disabled={false}
                    />
                    </div>
                </div>
                <div>
                    <button type='button' className='icon-button filter-clear-btn' onClick={limpiarFiltros}>
                        Limpiar filtros
                    </button>
                </div>
            </div>
        </form>
    );
};

export default LIFromFiltrosProducto;
